var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { injectIntl, defineMessages } from "react-intl";
import Loader from "../../../Loader";
import { getRecentVisitedGames } from "../../../../actions/games/creators";
import GamesList from "../GamesList";
var messages = defineMessages({
    recent: {
        id: "games.recent",
        defaultMessage: "Недавние",
    },
    empty_recent_games: {
        id: "empty_recent_games",
        defaultMessage: "У вас нет недавно посещённых игр",
    },
});
var GamesRecentVisited = /** @class */ (function (_super) {
    __extends(GamesRecentVisited, _super);
    function GamesRecentVisited() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GamesRecentVisited.prototype.render = function () {
        var _a = this.props, data = _a.data, isLoading = _a.isLoading, openGamesLoading = _a.openGamesLoading;
        var recentVisitedGames = data.Items;
        return (_jsxs("div", { children: [(isLoading || openGamesLoading) && _jsx(Loader, {}), _jsx("div", __assign({ style: {
                        margin: "10px 10px 0px",
                        color: "#fff",
                        padding: "10px 30px",
                        backgroundColor: "gray",
                        width: "fit-content",
                        border: this.props.darkTheme && "1px solid #afafaf",
                    } }, { children: this.props.intl.formatMessage(messages.recent) })), recentVisitedGames && !recentVisitedGames.length && (_jsx("h3", __assign({ style: { padding: "40px", textAlign: "center" } }, { children: this.props.intl.formatMessage(messages.empty_recent_games) }))), _jsx(GamesList, { fetchData: this.props.getRecentVisitedGamesAction })] }));
    };
    return GamesRecentVisited;
}(React.Component));
var mapStateToProps = function (state) {
    var _a = state.games.games, data = _a.data, isLoading = _a.isLoading;
    var openGamesLoading = state.games.openGame.isLoading;
    return {
        data: data,
        isLoading: isLoading,
        openGamesLoading: openGamesLoading,
        user: state.auth.user,
        langId: state.application.get("languageId"),
        darkTheme: state.application.get("darkTheme"),
    };
};
var mapDispatchToProps = {
    getRecentVisitedGamesAction: getRecentVisitedGames,
};
export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(GamesRecentVisited)));



// WEBPACK FOOTER //
// ./src/components/games/components/GamesRecentVisited/GamesRecentVisited.jsx